// extracted by mini-css-extract-plugin
export default {"responsive":"fastResponderBadge_responsive__e9nX2"};